
// src/components/ScrollTrackingWrapper.jsx
import React from 'react';
import useScrollTracking from '../hooks/useScrollTracking';

const ScrollTrackingWrapper = ({ 
  children, 
  handleScrollChange, 
  isMobile, 
  currentOrientation 
}) => {
  // Always call the hook at the top level
  useScrollTracking((direction, delta) => {
    // Only process the scroll events if we're in mobile portrait mode
    if (isMobile && currentOrientation === 'portrait' && handleScrollChange) {
      handleScrollChange(direction, delta);
    }
  });

  // Simply render the children
  return <>{children}</>;
};

export default ScrollTrackingWrapper;